export type ValidationSeverity = "error" | "warning" | "unverified" | "info"

export interface ValidationFinding {
  rule: string
  severity: ValidationSeverity
  message: string
  detail?: string
}

export interface EmailTemplateContent {
  htmlContent: string
  plainContent: string
}

export type AssetStatus = "available" | "unreachable" | "unverified"

export interface AssetCheck {
  url: string
  // Absolute http(s) URL. Relative and protocol-relative sources cannot resolve
  // once the template is sent, so they are never probed.
  absolute: boolean
  // Embedded in the message itself (data: or cid:), so there is nothing to
  // resolve or probe.
  inline: boolean
  // Served from an approved So Energy asset host.
  allowed: boolean
  status: AssetStatus
  // Pixel dimensions from the loaded image (bytes are not readable
  // cross-origin), null when the asset could not be loaded.
  width: number | null
  height: number | null
}

export const ALLOWED_ASSET_URLS = [
  "https://soenergy-production.s3-eu-west-1.amazonaws.com/",
  "https://soenergy-production.s3.eu-west-1.amazonaws.com/",
  "https://storage.googleapis.com/soenergy-production/",
]
